// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2iZQe","productName":"Table_productName__1N0KE"};